<template>
  <div class="flex w-full flex-col gap-2 sm:flex-row sm:items-center">
    <div class="flex w-full overflow-hidden rounded border border-gray-200 bg-white shadow-sm">
      <dropdown :auto-close="false" class="focus:z-10 px-4 hover:bg-gray-50 border-r border-gray-200 focus:border-white focus:ring md:px-5" placement="bottom-start">
        <template #default>
          <div class="flex h-full items-center">
            <span class="hidden text-xs font-bold uppercase text-gray-500 md:inline">Filter</span>
            <svg class="w-2 h-2 fill-gray-500 md:ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 961.243 599.998">
              <path d="M239.998 239.999L0 0h961.243L721.246 240c-131.999 132-240.28 240-240.624 239.999-.345-.001-108.625-108.001-240.624-240z" />
            </svg>
          </div>
        </template>
        <template #dropdown>
          <div class="mt-2 px-4 py-5 w-screen bg-white rounded shadow-xl border border-gray-100" :style="{ maxWidth: `${maxWidth}px` }">
            <slot />
          </div>
        </template>
      </dropdown>
      <input class="relative w-full px-4 py-2.5 text-sm text-gray-800 focus:outline-none" autocomplete="off" type="text" name="search" placeholder="Search order, email, or phone" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" />
    </div>
    <button class="text-sm font-bold text-gray-500 hover:text-indigo-600 focus:text-indigo-600 sm:ml-1" type="button" @click="$emit('reset')">Reset</button>
  </div>
</template>

<script>
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Dropdown,
  },
  props: {
    modelValue: String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
  emits: ['update:modelValue', 'reset'],
}
</script>
